import { Clear } from "@mui/icons-material";
import { Tooltip, Typography } from "@mui/material";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import { StyledPrestacionesCard } from "../../../styled/form";

// Styled components

const PrestacionesCard = ({ prestaciones, disabled, handleDelete }) => {
  const prestacionesState = useSelector((state) => state.forms.prestaciones);
  const affectedZonesState = useSelector((state) => state.forms.affectedZones);

  const getPrestacionNombre = (prestacion) => {
    const p = prestacionesState.data.find((p) => p.id === prestacion.id);
    return p ? p.nombre : undefined;
  };

  const getZonaAfectadaNombre = (prestacion) => {
    const za = affectedZonesState.data.find(
      (z) => z.id === prestacion.zonaAfectada,
    );
    return za ? za.nombre : undefined;
  };

  return (
    <StyledPrestacionesCard.Container>
      {prestaciones.map((prestacion) => (
        <StyledPrestacionesCard.Card
          key={prestacion.id + prestacion.zonaAfectada}>
          <StyledPrestacionesCard.InfoContainer elevation={2}>
            <StyledPrestacionesCard.PrestacionesContainer>
              <div>
                <Typography>{getPrestacionNombre(prestacion)}</Typography>
                <Typography>{getZonaAfectadaNombre(prestacion)}</Typography>
              </div>
              <Typography>{prestacion.cantidad}</Typography>
            </StyledPrestacionesCard.PrestacionesContainer>
            {prestacion.estado && prestacion.estado !== "Pendiente" && (
              <StyledPrestacionesCard.PrestacionesSolicitadasContainer>
                <StyledPrestacionesCard.RowContainer>
                  <Typography>{prestacion.estado}</Typography>
                  <Typography>
                    {prestacion.fechaAutorizacionArt
                      ? moment(prestacion.fechaAutorizacionArt).format(
                          "DD/MM/YYYY",
                        )
                      : ""}
                  </Typography>
                  <Typography>{prestacion.codigoAutorizacionArt}</Typography>
                </StyledPrestacionesCard.RowContainer>
                <Typography>{prestacion.cantidadAutorizada}</Typography>
              </StyledPrestacionesCard.PrestacionesSolicitadasContainer>
            )}
          </StyledPrestacionesCard.InfoContainer>
          <StyledPrestacionesCard.ActionContainer elevation={2}>
            <Tooltip
              title="Eliminar"
              sx={
                disabled ||
                (prestacion.estado && prestacion.estado !== "Pendiente")
                  ? StyledPrestacionesCard.disabledButton
                  : StyledPrestacionesCard.button
              }
              onClick={() => {
                if (
                  !disabled &&
                  (!prestacion.estado || prestacion.estado === "Pendiente")
                ) {
                  handleDelete(prestacion);
                }
              }}>
              <Clear sx={{ margin: "0px 15px 0px 0px" }} />
            </Tooltip>
          </StyledPrestacionesCard.ActionContainer>
        </StyledPrestacionesCard.Card>
      ))}
    </StyledPrestacionesCard.Container>
  );
};

export default PrestacionesCard;
